import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, DialogActions, DialogContent, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { AncillaryCostService } from "../../../../../Component/Api/merSETA/AncillaryCosts/AncillaryCostsService";
import { MerSETASDEService } from "../../../../../Component/Api/merSETA/External/MerSETASDEService";
import { MerSETALAIService } from "../../../../../Component/Api/merSETA/LAI/MerSETALAIService";
import AppCurrencyInput from "../../../../../Component/Common/Components/FormValidationInputs/AppCurrencyInput";
import { AppDatepicker } from "../../../../../Component/Common/Components/FormValidationInputs/AppDatepicker";
import AppTextInput from "../../../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import { MDButton } from "../../../../../Component/Common/Components/MDButton";
import { AncillaryCost } from "../../../../../Component/Model/Dto/WSP/AncillaryCost";
import { TrainingTypes } from "../../../../../Component/Model/Enum/BEE123Enums";
import { AncillaryCostValidationScheme } from "./AncillaryCostValidationScheme";
import { MerSETASDIService } from "../../../../../Component/Api/merSETA/Internal/MerSETASDIService";

interface IProps {
  interventionTypeId: number,
  selectedInterventionId: number,
  ancillaryCost?: AncillaryCost,
  setHandleNextCount: (i: number) => void,
  handleNextCount: number,
  closeModal: () => void,
  setAncillaryCostDataAfterCreate: (ancillaryCost: AncillaryCost) => void,
}

export const AncillaryCostDescription = (props: IProps) => {
  const { control, handleSubmit, formState: { isSubmitting }, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(AncillaryCostValidationScheme),
  });
  const [interventionName, setInterventionName] = React.useState<string>("");

  useEffect(() => {
    fetchData();
  }, [])

  const isEditing = () => {
    return props.ancillaryCost?.id != null;
  }

  const fetchData = async () => {
    try {
      if (props.interventionTypeId === TrainingTypes.LAI) {
        let intervention = await MerSETALAIService.GetById(props.selectedInterventionId);
        setInterventionName(intervention.data.courseName);
      } else if (props.interventionTypeId === TrainingTypes.External) {
        let intervention = await MerSETASDEService.GetById(props.selectedInterventionId);
        setInterventionName(intervention.data.courseName);
      } else if (props.interventionTypeId === TrainingTypes.Internal) {
        let intervention = await MerSETASDIService.GetById(props.selectedInterventionId);
        setInterventionName(intervention.data.courseName);
      }
      if (isEditing()) {
        reset(props.ancillaryCost);
      }
    } catch (error: any) {
      console.error(error);
    }
  }

  const handleDataSubmit = async (data: FieldValues) => {
    let ancillaryCostRequest = {
      id: props.ancillaryCost?.id,
      cost: data.cost.replace(/\s/g, '').replace(',', '.'),
      description: data.description,
      paymentDate: data.paymentDate,
      interventionId: props.selectedInterventionId,
      interventionTypeId: props.interventionTypeId
    } as AncillaryCost;

    try {
      if (isEditing()) {
        await AncillaryCostService.Update(ancillaryCostRequest);
        toast.success("Ancillary Cost saved ");
      }
      else {
        const result = await AncillaryCostService.Create(ancillaryCostRequest!);
        props.setAncillaryCostDataAfterCreate(result.data);
        toast.success("Ancillary Cost created successfully ");
      }
      props.setHandleNextCount(props.handleNextCount + 1);
    } catch (error: any) {
      console.error(error);
      toast.error("Could not save Ancillary Cost");
    }

  }

  return (
    <Box>
      <form id='AncillaryCostForm' onSubmit={handleSubmit(handleDataSubmit)}>
        <Grid container mb={3} ml={0.5} spacing={1}>
          <Typography variant="body2">
            {isEditing() ? "Edit ancillary cost for" : "Capture ancillary cost for"} {interventionName}.
          </Typography>
        </Grid>
        <Grid container mb={2} spacing={1}>
          <Grid item xs={12} sm={12}>
            <AppTextInput label='Description *' name='description' control={control} />
          </Grid>
        </Grid>
        <Grid container mb={2} spacing={1}>
          <Grid item xs={6} sm={6}>
            <AppDatepicker label='Payment Date *' name='paymentDate' control={control} inputFormat="yyyy/MM/dd" />
          </Grid>
          <Grid item xs={6} sm={6}>
            <AppCurrencyInput label='Cost(excl. VAT) *' name='cost' control={control} onlyAllowCurrency />
          </Grid>
        </Grid>
      </form>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: -1 }}>
        <MDButton variant='outlined' color='primary' onClick={() => props.closeModal()}>Cancel</MDButton>
        <LoadingButton loading={isSubmitting} variant='contained' form='AncillaryCostForm' type="submit" color='primary'>Save and Continue</LoadingButton>
      </Box>
    </Box>
  )
}

